/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/dashboard/route'
import { Route as IndexImport } from './routes/index'
import { Route as PaymentSuccessIndexImport } from './routes/payment-success/index'
import { Route as PayIndexImport } from './routes/pay/index'
import { Route as DashboardIndexImport } from './routes/dashboard/index'
import { Route as AuthSignInImport } from './routes/auth/sign-in'
import { Route as DashboardChatIndexImport } from './routes/dashboard/chat/index'
import { Route as DashboardAnalyticsIndexImport } from './routes/dashboard/analytics/index'
import { Route as DashboardAdminIndexImport } from './routes/dashboard/admin/index'
import { Route as DashboardAdminUsersRouteImport } from './routes/dashboard/admin/users/route'
import { Route as DashboardAdminContactRouteImport } from './routes/dashboard/admin/contact/route'
import { Route as DashboardAdminProductsIndexImport } from './routes/dashboard/admin/products/index'
import { Route as DashboardAdminProceduresIndexImport } from './routes/dashboard/admin/procedures/index'
import { Route as DashboardAdminNotificationIndexImport } from './routes/dashboard/admin/notification/index'
import { Route as DashboardAdminDoctorsIndexImport } from './routes/dashboard/admin/doctors/index'
import { Route as DashboardAdminBrandsIndexImport } from './routes/dashboard/admin/brands/index'
import { Route as DashboardAdminContactListIndexImport } from './routes/dashboard/admin/contact/list/index'
import { Route as DashboardAdminContactDetailsIndexImport } from './routes/dashboard/admin/contact/details/index'
import { Route as DashboardAdminContactDetailsContactIdImport } from './routes/dashboard/admin/contact/details/$contactId'

// Create/Update Routes

const DashboardRouteRoute = DashboardRouteImport.update({
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PaymentSuccessIndexRoute = PaymentSuccessIndexImport.update({
  path: '/payment-success/',
  getParentRoute: () => rootRoute,
} as any)

const PayIndexRoute = PayIndexImport.update({
  path: '/pay/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const AuthSignInRoute = AuthSignInImport.update({
  path: '/auth/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const DashboardChatIndexRoute = DashboardChatIndexImport.update({
  path: '/chat/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardAnalyticsIndexRoute = DashboardAnalyticsIndexImport.update({
  path: '/analytics/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardAdminIndexRoute = DashboardAdminIndexImport.update({
  path: '/admin/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardAdminUsersRouteRoute = DashboardAdminUsersRouteImport.update({
  path: '/admin/users',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardAdminContactRouteRoute = DashboardAdminContactRouteImport.update(
  {
    path: '/admin/contact',
    getParentRoute: () => DashboardRouteRoute,
  } as any,
)

const DashboardAdminProductsIndexRoute =
  DashboardAdminProductsIndexImport.update({
    path: '/admin/products/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

const DashboardAdminProceduresIndexRoute =
  DashboardAdminProceduresIndexImport.update({
    path: '/admin/procedures/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

const DashboardAdminNotificationIndexRoute =
  DashboardAdminNotificationIndexImport.update({
    path: '/admin/notification/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

const DashboardAdminDoctorsIndexRoute = DashboardAdminDoctorsIndexImport.update(
  {
    path: '/admin/doctors/',
    getParentRoute: () => DashboardRouteRoute,
  } as any,
)

const DashboardAdminBrandsIndexRoute = DashboardAdminBrandsIndexImport.update({
  path: '/admin/brands/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardAdminContactListIndexRoute =
  DashboardAdminContactListIndexImport.update({
    path: '/list/',
    getParentRoute: () => DashboardAdminContactRouteRoute,
  } as any)

const DashboardAdminContactDetailsIndexRoute =
  DashboardAdminContactDetailsIndexImport.update({
    path: '/details/',
    getParentRoute: () => DashboardAdminContactRouteRoute,
  } as any)

const DashboardAdminContactDetailsContactIdRoute =
  DashboardAdminContactDetailsContactIdImport.update({
    path: '/details/$contactId',
    getParentRoute: () => DashboardAdminContactRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/pay/': {
      id: '/pay/'
      path: '/pay'
      fullPath: '/pay'
      preLoaderRoute: typeof PayIndexImport
      parentRoute: typeof rootRoute
    }
    '/payment-success/': {
      id: '/payment-success/'
      path: '/payment-success'
      fullPath: '/payment-success'
      preLoaderRoute: typeof PaymentSuccessIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/admin/contact': {
      id: '/dashboard/admin/contact'
      path: '/admin/contact'
      fullPath: '/dashboard/admin/contact'
      preLoaderRoute: typeof DashboardAdminContactRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/admin/users': {
      id: '/dashboard/admin/users'
      path: '/admin/users'
      fullPath: '/dashboard/admin/users'
      preLoaderRoute: typeof DashboardAdminUsersRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/admin/': {
      id: '/dashboard/admin/'
      path: '/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof DashboardAdminIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/analytics/': {
      id: '/dashboard/analytics/'
      path: '/analytics'
      fullPath: '/dashboard/analytics'
      preLoaderRoute: typeof DashboardAnalyticsIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/chat/': {
      id: '/dashboard/chat/'
      path: '/chat'
      fullPath: '/dashboard/chat'
      preLoaderRoute: typeof DashboardChatIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/admin/brands/': {
      id: '/dashboard/admin/brands/'
      path: '/admin/brands'
      fullPath: '/dashboard/admin/brands'
      preLoaderRoute: typeof DashboardAdminBrandsIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/admin/doctors/': {
      id: '/dashboard/admin/doctors/'
      path: '/admin/doctors'
      fullPath: '/dashboard/admin/doctors'
      preLoaderRoute: typeof DashboardAdminDoctorsIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/admin/notification/': {
      id: '/dashboard/admin/notification/'
      path: '/admin/notification'
      fullPath: '/dashboard/admin/notification'
      preLoaderRoute: typeof DashboardAdminNotificationIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/admin/procedures/': {
      id: '/dashboard/admin/procedures/'
      path: '/admin/procedures'
      fullPath: '/dashboard/admin/procedures'
      preLoaderRoute: typeof DashboardAdminProceduresIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/admin/products/': {
      id: '/dashboard/admin/products/'
      path: '/admin/products'
      fullPath: '/dashboard/admin/products'
      preLoaderRoute: typeof DashboardAdminProductsIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/admin/contact/details/$contactId': {
      id: '/dashboard/admin/contact/details/$contactId'
      path: '/details/$contactId'
      fullPath: '/dashboard/admin/contact/details/$contactId'
      preLoaderRoute: typeof DashboardAdminContactDetailsContactIdImport
      parentRoute: typeof DashboardAdminContactRouteImport
    }
    '/dashboard/admin/contact/details/': {
      id: '/dashboard/admin/contact/details/'
      path: '/details'
      fullPath: '/dashboard/admin/contact/details'
      preLoaderRoute: typeof DashboardAdminContactDetailsIndexImport
      parentRoute: typeof DashboardAdminContactRouteImport
    }
    '/dashboard/admin/contact/list/': {
      id: '/dashboard/admin/contact/list/'
      path: '/list'
      fullPath: '/dashboard/admin/contact/list'
      preLoaderRoute: typeof DashboardAdminContactListIndexImport
      parentRoute: typeof DashboardAdminContactRouteImport
    }
  }
}

// Create and export the route tree

interface DashboardAdminContactRouteRouteChildren {
  DashboardAdminContactDetailsContactIdRoute: typeof DashboardAdminContactDetailsContactIdRoute
  DashboardAdminContactDetailsIndexRoute: typeof DashboardAdminContactDetailsIndexRoute
  DashboardAdminContactListIndexRoute: typeof DashboardAdminContactListIndexRoute
}

const DashboardAdminContactRouteRouteChildren: DashboardAdminContactRouteRouteChildren =
  {
    DashboardAdminContactDetailsContactIdRoute:
      DashboardAdminContactDetailsContactIdRoute,
    DashboardAdminContactDetailsIndexRoute:
      DashboardAdminContactDetailsIndexRoute,
    DashboardAdminContactListIndexRoute: DashboardAdminContactListIndexRoute,
  }

const DashboardAdminContactRouteRouteWithChildren =
  DashboardAdminContactRouteRoute._addFileChildren(
    DashboardAdminContactRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardAdminContactRouteRoute: typeof DashboardAdminContactRouteRouteWithChildren
  DashboardAdminUsersRouteRoute: typeof DashboardAdminUsersRouteRoute
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
  DashboardAnalyticsIndexRoute: typeof DashboardAnalyticsIndexRoute
  DashboardChatIndexRoute: typeof DashboardChatIndexRoute
  DashboardAdminBrandsIndexRoute: typeof DashboardAdminBrandsIndexRoute
  DashboardAdminDoctorsIndexRoute: typeof DashboardAdminDoctorsIndexRoute
  DashboardAdminNotificationIndexRoute: typeof DashboardAdminNotificationIndexRoute
  DashboardAdminProceduresIndexRoute: typeof DashboardAdminProceduresIndexRoute
  DashboardAdminProductsIndexRoute: typeof DashboardAdminProductsIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardAdminContactRouteRoute: DashboardAdminContactRouteRouteWithChildren,
  DashboardAdminUsersRouteRoute: DashboardAdminUsersRouteRoute,
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
  DashboardAnalyticsIndexRoute: DashboardAnalyticsIndexRoute,
  DashboardChatIndexRoute: DashboardChatIndexRoute,
  DashboardAdminBrandsIndexRoute: DashboardAdminBrandsIndexRoute,
  DashboardAdminDoctorsIndexRoute: DashboardAdminDoctorsIndexRoute,
  DashboardAdminNotificationIndexRoute: DashboardAdminNotificationIndexRoute,
  DashboardAdminProceduresIndexRoute: DashboardAdminProceduresIndexRoute,
  DashboardAdminProductsIndexRoute: DashboardAdminProductsIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/pay': typeof PayIndexRoute
  '/payment-success': typeof PaymentSuccessIndexRoute
  '/dashboard/admin/contact': typeof DashboardAdminContactRouteRouteWithChildren
  '/dashboard/admin/users': typeof DashboardAdminUsersRouteRoute
  '/dashboard/admin': typeof DashboardAdminIndexRoute
  '/dashboard/analytics': typeof DashboardAnalyticsIndexRoute
  '/dashboard/chat': typeof DashboardChatIndexRoute
  '/dashboard/admin/brands': typeof DashboardAdminBrandsIndexRoute
  '/dashboard/admin/doctors': typeof DashboardAdminDoctorsIndexRoute
  '/dashboard/admin/notification': typeof DashboardAdminNotificationIndexRoute
  '/dashboard/admin/procedures': typeof DashboardAdminProceduresIndexRoute
  '/dashboard/admin/products': typeof DashboardAdminProductsIndexRoute
  '/dashboard/admin/contact/details/$contactId': typeof DashboardAdminContactDetailsContactIdRoute
  '/dashboard/admin/contact/details': typeof DashboardAdminContactDetailsIndexRoute
  '/dashboard/admin/contact/list': typeof DashboardAdminContactListIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/dashboard': typeof DashboardIndexRoute
  '/pay': typeof PayIndexRoute
  '/payment-success': typeof PaymentSuccessIndexRoute
  '/dashboard/admin/contact': typeof DashboardAdminContactRouteRouteWithChildren
  '/dashboard/admin/users': typeof DashboardAdminUsersRouteRoute
  '/dashboard/admin': typeof DashboardAdminIndexRoute
  '/dashboard/analytics': typeof DashboardAnalyticsIndexRoute
  '/dashboard/chat': typeof DashboardChatIndexRoute
  '/dashboard/admin/brands': typeof DashboardAdminBrandsIndexRoute
  '/dashboard/admin/doctors': typeof DashboardAdminDoctorsIndexRoute
  '/dashboard/admin/notification': typeof DashboardAdminNotificationIndexRoute
  '/dashboard/admin/procedures': typeof DashboardAdminProceduresIndexRoute
  '/dashboard/admin/products': typeof DashboardAdminProductsIndexRoute
  '/dashboard/admin/contact/details/$contactId': typeof DashboardAdminContactDetailsContactIdRoute
  '/dashboard/admin/contact/details': typeof DashboardAdminContactDetailsIndexRoute
  '/dashboard/admin/contact/list': typeof DashboardAdminContactListIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/pay/': typeof PayIndexRoute
  '/payment-success/': typeof PaymentSuccessIndexRoute
  '/dashboard/admin/contact': typeof DashboardAdminContactRouteRouteWithChildren
  '/dashboard/admin/users': typeof DashboardAdminUsersRouteRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/analytics/': typeof DashboardAnalyticsIndexRoute
  '/dashboard/chat/': typeof DashboardChatIndexRoute
  '/dashboard/admin/brands/': typeof DashboardAdminBrandsIndexRoute
  '/dashboard/admin/doctors/': typeof DashboardAdminDoctorsIndexRoute
  '/dashboard/admin/notification/': typeof DashboardAdminNotificationIndexRoute
  '/dashboard/admin/procedures/': typeof DashboardAdminProceduresIndexRoute
  '/dashboard/admin/products/': typeof DashboardAdminProductsIndexRoute
  '/dashboard/admin/contact/details/$contactId': typeof DashboardAdminContactDetailsContactIdRoute
  '/dashboard/admin/contact/details/': typeof DashboardAdminContactDetailsIndexRoute
  '/dashboard/admin/contact/list/': typeof DashboardAdminContactListIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/auth/sign-in'
    | '/dashboard/'
    | '/pay'
    | '/payment-success'
    | '/dashboard/admin/contact'
    | '/dashboard/admin/users'
    | '/dashboard/admin'
    | '/dashboard/analytics'
    | '/dashboard/chat'
    | '/dashboard/admin/brands'
    | '/dashboard/admin/doctors'
    | '/dashboard/admin/notification'
    | '/dashboard/admin/procedures'
    | '/dashboard/admin/products'
    | '/dashboard/admin/contact/details/$contactId'
    | '/dashboard/admin/contact/details'
    | '/dashboard/admin/contact/list'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth/sign-in'
    | '/dashboard'
    | '/pay'
    | '/payment-success'
    | '/dashboard/admin/contact'
    | '/dashboard/admin/users'
    | '/dashboard/admin'
    | '/dashboard/analytics'
    | '/dashboard/chat'
    | '/dashboard/admin/brands'
    | '/dashboard/admin/doctors'
    | '/dashboard/admin/notification'
    | '/dashboard/admin/procedures'
    | '/dashboard/admin/products'
    | '/dashboard/admin/contact/details/$contactId'
    | '/dashboard/admin/contact/details'
    | '/dashboard/admin/contact/list'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/auth/sign-in'
    | '/dashboard/'
    | '/pay/'
    | '/payment-success/'
    | '/dashboard/admin/contact'
    | '/dashboard/admin/users'
    | '/dashboard/admin/'
    | '/dashboard/analytics/'
    | '/dashboard/chat/'
    | '/dashboard/admin/brands/'
    | '/dashboard/admin/doctors/'
    | '/dashboard/admin/notification/'
    | '/dashboard/admin/procedures/'
    | '/dashboard/admin/products/'
    | '/dashboard/admin/contact/details/$contactId'
    | '/dashboard/admin/contact/details/'
    | '/dashboard/admin/contact/list/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  AuthSignInRoute: typeof AuthSignInRoute
  PayIndexRoute: typeof PayIndexRoute
  PaymentSuccessIndexRoute: typeof PaymentSuccessIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  AuthSignInRoute: AuthSignInRoute,
  PayIndexRoute: PayIndexRoute,
  PaymentSuccessIndexRoute: PaymentSuccessIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/dashboard",
        "/auth/sign-in",
        "/pay/",
        "/payment-success/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/dashboard": {
      "filePath": "dashboard/route.tsx",
      "children": [
        "/dashboard/",
        "/dashboard/admin/contact",
        "/dashboard/admin/users",
        "/dashboard/admin/",
        "/dashboard/analytics/",
        "/dashboard/chat/",
        "/dashboard/admin/brands/",
        "/dashboard/admin/doctors/",
        "/dashboard/admin/notification/",
        "/dashboard/admin/procedures/",
        "/dashboard/admin/products/"
      ]
    },
    "/auth/sign-in": {
      "filePath": "auth/sign-in.tsx"
    },
    "/dashboard/": {
      "filePath": "dashboard/index.tsx",
      "parent": "/dashboard"
    },
    "/pay/": {
      "filePath": "pay/index.tsx"
    },
    "/payment-success/": {
      "filePath": "payment-success/index.tsx"
    },
    "/dashboard/admin/contact": {
      "filePath": "dashboard/admin/contact/route.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/admin/contact/details/$contactId",
        "/dashboard/admin/contact/details/",
        "/dashboard/admin/contact/list/"
      ]
    },
    "/dashboard/admin/users": {
      "filePath": "dashboard/admin/users/route.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/admin/": {
      "filePath": "dashboard/admin/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/analytics/": {
      "filePath": "dashboard/analytics/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/chat/": {
      "filePath": "dashboard/chat/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/admin/brands/": {
      "filePath": "dashboard/admin/brands/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/admin/doctors/": {
      "filePath": "dashboard/admin/doctors/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/admin/notification/": {
      "filePath": "dashboard/admin/notification/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/admin/procedures/": {
      "filePath": "dashboard/admin/procedures/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/admin/products/": {
      "filePath": "dashboard/admin/products/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/admin/contact/details/$contactId": {
      "filePath": "dashboard/admin/contact/details/$contactId.tsx",
      "parent": "/dashboard/admin/contact"
    },
    "/dashboard/admin/contact/details/": {
      "filePath": "dashboard/admin/contact/details/index.tsx",
      "parent": "/dashboard/admin/contact"
    },
    "/dashboard/admin/contact/list/": {
      "filePath": "dashboard/admin/contact/list/index.tsx",
      "parent": "/dashboard/admin/contact"
    }
  }
}
ROUTE_MANIFEST_END */
